<template>
  <a-row :gutter="10">
    <a-col :span="4">
      <vehicle @success="selectLog"/>
    </a-col>
    <a-col :span="20">
      <List ref="list"/>
    </a-col>
  </a-row>
</template>
<script>
import List from './List'
import vehicle from './vehicle.vue'
export default {
  components: {
    List,
    vehicle
  },
  data() {
    return {}
  },
  methods: {
    selectLog(vehicle) {
      this.$refs.list.setVehicle(vehicle)
    },
  },
}

</script>
